// extracted by mini-css-extract-plugin
export default {"mainContentSection":"applicationHome_mainContentSection__tYE6E","copyRightText":"applicationHome_copyRightText__cyjBj"};